package com.fireavert.auth.reset_password.client.presentation

import com.fireavert.auth.reset_password.client.ResetPasswordUseCase

class ResetPasswordController(private val useCase: ResetPasswordUseCase) {
    fun emailChanged(targetInputValue: String) = useCase.emailChanged(targetInputValue)
    suspend fun clickedSubmit() = useCase.submit()
}